<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 添加按钮 -->
      <template #start>
        <el-form-item v-if="user && ![2, 3, 4].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" icon="el-icon-plus" @click="addOrder">添加</el-button>
        </el-form-item>
      </template>
      <template #beforeBtn>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormDate>
        <!-- 复合搜索框 -->
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
      <template #end>
        <!-- 导出按钮 -->
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`合同运单_外协车辆`)">导出</el-button>
        </el-form-item>

        <!-- 过磅单导出 -->
        <el-form-item class="endBtn" v-if="user && [1, 2, 3, 4, 5].includes(user.user_group_id)">
          <el-button class="exportBtn" type="primary" :loading="btnloading" @click="getExport">
            <i v-if="!btnloading" class="el-icon-folder"></i>
            导出
          </el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import ordermixin from "../../nonContractOrder/own/mixin";
import mixin from "../own/mixin";

export default {
  name: "ContractList",
  mixins: [tableMixin, ordermixin, mixin],
  data() {
    return {
      baseUrl: 'order',
      formInline: {
        order_type: 2,
        ischeck: 2,
        isstatus: 4,
      },
      formCtrl: [],
      curSearchKey: 'shname',
      curSearchValue: undefined,
      searchKeyOptions: [
        { label: '承运公司', value: 'pcustomname', },
        { label: '客户名称', value: 'shname', },
        { label: '车牌号', value: 'license', },
      ],
      cols: [
        { keyName: "con_num", label: "合同编号", minwidth: 120 },
        { keyName: "order_num", label: "运单编号", minwidth: 150 },
        { keyName: "pcustomname", label: "承运公司", minwidth: 150 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "shname", label: "客户名称", minwidth: 120 },
        { keyName: "name", label: "货物名称", minwidth: 110 },
        { keyName: "pricing", label: "计价方式", minwidth: 110 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { ...this.ctrls.XieHuoRiQi, minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', width: 110 },
        { keyName: "caton", label: "计算量", align: 'right', className: 'pr30', width: 110 },
        { keyName: "ceton", label: "客担亏吨", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "cprice", label: "运费单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dprice", label: "承运单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "freight", label: "运费金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "infreight", label: "承运金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "additional_fees", label: "附加费用", minwidth: 120 },
        { keyName: "compen", label: "运单补差", minwidth: 120 },
        { keyName: "ys_freight", label: "应收运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "yf_freight", label: "应付运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "nickname", label: "派单人", minwidth: 120 },
        { keyName: "repaytime", label: "预计结款日期", minwidth: 120 },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id }) => {
            // console.log(id)
            let path = `/order/contractdetail`
            if (this.$route.path === '/contract/orderlist/hire') {
              path = '/contract/orderDetail2'
            }
            this.$router.push({
              path,
              query: {
                id,
                mode: 'edit',
              }
            });
          },
        },
        {
          ...this.delBtn,
          cb: this.delete,
        },
      ],
      getTotalProperty: [
        'caton',
        'inton',
        'unton',
        'kuiton',
        'kuitotal',
        'infreight',
        'freight',
        'additional_fees',
        'compen',
        'ys_freight',
        'yf_freight',
      ],
      baseParams: [
        'order_type',
        'ischeck',
        'isstatus',
      ],
    };
  },
  methods: {
    addOrder() {
      this.$router.push("/order/contractaddhire");
    },
  },
  created() {
    const { id } = this.$route.query
    // console.log('created', id)
    if (id) {
      // 如果页面带id参数，说明是合同跳转过来的，搜索时加上合同id
      this.formInline.contractid = id
      this.searchKeyOptions = [
        { label: '承运公司', value: 'pcustomname', },
        { label: '车牌号', value: 'license', },
      ]
    }
  },
  mounted() { },
};
</script>
